// DynamicFilterBar.js
import React from 'react';
import { MaintenanceSelect } from './MaintenanceSelect';
import { Button } from '../../../common/APICommon';
import { clsx } from 'clsx';
import { cn } from '../../../utils/cn';

export const DynamicFilterBar = ({
  requestedFilters,
  activeFilterState,
  onFilterChange,
  onApply,
  onClear,
  showButtons = true,
  allowAll = true, // for dropdown
  containerClass = "",
  // New prop with your current layout as the default
  gridClass = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-3"
}) => {
  return (
    <div className={cn("w-full", containerClass)}>
      {/* 
          We use cn() here so that if you pass a new 'grid-cols' 
          via gridClass, it overrides the default one. 
      */}
      <div className={cn(gridClass)}>
        {requestedFilters.map(key => (
          <div key={key} className="flex-1 min-w-[200px]">
            <MaintenanceSelect
              type={key}
              value={activeFilterState[key]}
              activeFilterState={activeFilterState}
              onChange={(val) => onFilterChange(key, val)}
              allowAll={allowAll}
            />
          </div>
        ))}
      </div>

      {showButtons && (
        <div className="flex row gap-2 mt-6">
          <Button
            name={"Generate"}
            className={"px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white border-none cursor-pointer rounded shadow-sm"}
            onClick={onApply}
          />
          <Button
            name={"Clear"}
            className={"px-5 py-2 bg-gray-400 hover:bg-gray-500 text-white border-none cursor-pointer rounded shadow-sm"}
            onClick={onClear}
          />
        </div>
      )}
    </div>
  );
};